import React, { Fragment, useState, useEffect, useRef } from "react";
import { Redirect } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import loading from "../components/loading.json";
import { themeStyle, themeStyleDark } from "../components/Components";
import { gsap } from "gsap";
import Backdrop from "@mui/material/Backdrop";
import bg from "../bg.mp4";
import Sidebar from "../components/Sidebar";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { Grid } from "@mui/material";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import Footer from "../components/Footer";
import CountUp from "react-countup";
import Benchmark from "./Benchmark";
import HistoryIcon from "@mui/icons-material/History";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import SchoolIcon from "@mui/icons-material/School";
import AllInclusiveIcon from "@mui/icons-material/AllInclusive";
import RadarIcon from "@mui/icons-material/Radar";
import CastForEducationIcon from "@mui/icons-material/CastForEducation";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import SelfImprovementIcon from "@mui/icons-material/SelfImprovement";
import SportsBasketballIcon from "@mui/icons-material/SportsBasketball";
import LibraryMusicIcon from "@mui/icons-material/LibraryMusic";
import ClassIcon from "@mui/icons-material/Class";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import FavoriteIcon from "@mui/icons-material/Favorite";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import Explore from "./Explore";
import VisitUs from "../components/VisitUs";

export default function Dashboard() {
  const [transition, setTransition] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [newsTranslate, setNewsTranslate] = useState(0);
  const [newsCount, setNewsCount] = useState(1);

  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const ref = useRef([]);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(-200, -200);
    setTimeout(() => setTransition(true), 500);
    setTimeout(() => {
      gsap.to(".loader", { opacity: 0, duration: 0.1 }).then(() => {
        setIsLoading(false);

        setTimeout(() => {
          setInterval(() => {
            gsap
              .to(".newsDot", {
                opacity: 0,
                scale: 6,
                duration: 0.5,
              })
              .then(() => {
                gsap.to(".newsDot", {
                  opacity: 1,
                  scale: 1,
                  duration: 0,
                });
              });
          }, 1000);
          gsap.to(".hero, .video, .overlay", {
            opacity: 1,
            duration: 0.1,
          });
          let newsItems = gsap.utils.toArray(".icard");

          newsItems.forEach((item, i) => {
            let hover = gsap.to(item, {
              scale: 1.025,
              color:
                state.auth.theme == "dark"
                  ? themeStyleDark.primaryButtonTextColor
                  : themeStyle.primaryButtonTextColor,
              duration: 0.3,
              paused: true,
              ease: "power2.inOut",
            });
            item.addEventListener("mouseenter", () => {
              hover.play();
            });
            item.addEventListener("mouseleave", () => {
              hover.reverse();
            });
          });
        }, 100);
      });
    }, 500);
  }, []);

  function newsLeft() {
    if (newsCount > 0) {
      gsap.to(".newsSlider", {
        translateX: newsTranslate + 200,
        duration: 0.5,
      });
      setNewsTranslate(newsTranslate + 200);
      setNewsCount(newsCount - 1);
      dispatch({
        type: "NAV_COLOR",
        payload: { navColor: themeStyle.secondaryButtonColor, navOpacity: 1 },
      });
    }
  }

  function newsRight() {
    if (newsCount < 2) {
      gsap.to(".newsSlider", {
        translateX: newsTranslate - 200,
        duration: 0.5,
      });
      setNewsTranslate(newsTranslate - 200);
      setNewsCount(newsCount + 1);
      dispatch({
        type: "NAV_COLOR",
        payload: { navColor: themeStyle.secondaryButtonColor, navOpacity: 1 },
      });
    }
  }

  function getContent() {
    if (isLoading) {
      return (
        <Lottie
          className="loader"
          style={{ height: "0" }}
          animationData={loading}
          loop={true}
        />
      );
    } else {
      return (
        <div className="main">
          <Sidebar />
          {/* <div className="overlay"></div> */}
          <div
            style={{
              height: "75px",
              width: "75px",
              borderRadius: "40px",
              backgroundColor: "black",
              position: "fixed",
              right: 20,
              zIndex: 4,
              bottom: 20,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              opacity: 0,
            }}
            onClick={() => {
              window.scrollTo(0, 0);
            }}
            className="takemeup"
          >
            <ArrowUpwardIcon style={{ color: "white", fontSize: "40px" }} />
          </div>
          {/* <video
            src={bg}
            type="video/mp4"
            autoPlay
            loop
            muted
            id="video"
            className="video"
          />{" "} */}
          <img
            style={{ width: "100vw", height: "100vh", objectFit: "cover" }}
            src={require("../img/AGIS (7).jpeg")}
          />
          <div
            className="herotitle"
            style={{
              marginTop: state.auth.isMobile ? "-80vh" : "-65vh",
              marginBottom: "50vh",
              textAlign: "center",
              height: "200px",
              width: "100vw",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: state.auth.isMobile ? "40px" : "75px",
              fontWeight: "bold",
              fontFamily: "Montserrat",
              textShadow: "8px 8px 8px black",
              color:
                state.auth.theme == "dark"
                  ? themeStyleDark.primaryButtonTextColor
                  : themeStyle.primaryButtonTextColor,
            }}
          >
            WELCOME TO ASPIRE GROVE INTERNATIONAL PRESCHOOL
          </div>
          <div className="hero" style={{}}>
            <div
              style={{
                fontSize: state.auth.isMobile ? "30px" : "55px",
                fontWeight: "bold",
                fontFamily: "Montserrat",
                color: themeStyle.primaryColor,
                marginTop: "50px",
              }}
            >
              ASPIRE Grove International Pre-School, Devanahalli Premium
              International Pre-School
            </div>
            <br />
            <br />
            <div
              style={{
                textAlign: "justify",
                fontSize: state.auth.isMobile ? "20px" : "30px",
                fontWeight: "bold",
                fontFamily: "Montserrat",
                marginBottom: "30px",
              }}
            >
              Welcome to Aspire Grove International Preschool, a vibrant world
              where little minds explore, imaginations soar, and every day is an
              adventure filled with play and laughter.
            </div>
            <div
              onClick={() => navigate("about_school")}
              style={{
                marginBottom: "100px",
                cursor: "pointer",
                textAlign: "left",
                fontSize: state.auth.isMobile ? "20px" : "30px",
                fontWeight: "bold",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
                fontFamily: "Montserrat",
                textDecoration: "underline",
              }}
            >
              Learn more about ASPIRE Grove International Pre-School,
              Devanahalli Premium International Pre-School
            </div>
          </div>
          {/* <div className="growth">
            <div
              style={{
                marginTop: "-650px",
                display: "flex",
                flexDirection: "column",
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  marginTop: "100px",
                  display: "flex",
                  width: "100%",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    height: "500px",
                    width: "15%",
                    backgroundColor: "white",
                    zIndex: 3,
                  }}
                ></div>
                <div
                  style={{
                    height: "300px",
                    width: "70%",
                    backgroundColor: "white",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div
                    onClick={() => newsLeft()}
                    style={{
                      height: "40px",
                      width: "40px",
                      borderRadius: "10px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                      zIndex: 3,
                    }}
                  >
                    <ChevronLeftIcon
                      style={{ color: "white", fontSize: "40px" }}
                    />
                  </div>
                  <div
                    onClick={() => newsRight()}
                    style={{
                      height: "40px",
                      width: "40px",
                      borderRadius: "10px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                      zIndex: 3,
                    }}
                  >
                    <ChevronRightIcon
                      style={{ color: "white", fontSize: "40px" }}
                    />
                  </div>
                </div>
                <div
                  style={{
                    height: "500px",
                    width: "15%",
                    backgroundColor: "white",
                    zIndex: 3,
                  }}
                ></div>
              </div>
              <div
                className="newsSlider"
                style={{
                  marginTop: "-252px",
                  height: "5px",
                  width: "100%",
                  backgroundColor:
                    state.auth.theme == "dark"
                      ? themeStyleDark.primaryColor
                      : themeStyle.primaryColor,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-around",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginTop: "180px",
                  }}
                >
                  <div
                    className="newsDot"
                    style={{
                      height: "15px",
                      width: "15px",
                      borderRadius: "15px",
                      marginTop: "65px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  ></div>
                  <div
                    style={{
                      height: "25px",
                      width: "25px",
                      marginTop: "-20px",
                      borderRadius: "15px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  ></div>
                  <div
                    style={{
                      textAlign :"justify",
                      fontSize: state.auth.isMobile ? "20px" : "30px",
                      fontWeight: "bold",
                      fontFamily: "Montserrat",
                    }}
                  >
                    1995
                  </div>
                  <div
                    style={{
                      textAlign :"justify",
                      width: "155px",
                      marginTop: "15px",
                      fontSize: "20px",
                      fontFamily: "Montserrat",
                    }}
                  >
                    SSLC Building was established at Our first building campus
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginTop: "180px",
                  }}
                >
                  <div
                    className="newsDot"
                    style={{
                      height: "15px",
                      width: "15px",
                      borderRadius: "15px",
                      marginTop: "65px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  ></div>
                  <div
                    style={{
                      height: "25px",
                      width: "25px",
                      marginTop: "-20px",
                      borderRadius: "15px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  ></div>
                  <div
                    style={{
                      textAlign :"justify",
                      fontSize: state.auth.isMobile ? "20px" : "30px",
                      fontWeight: "bold",
                      fontFamily: "Montserrat",
                    }}
                  >
                    1996
                  </div>
                  <div
                    style={{
                      textAlign :"justify",
                      width: "155px",
                      marginTop: "15px",
                      fontSize: "20px",
                      fontFamily: "Montserrat",
                    }}
                  >
                    SSLC Building was established at Our first building campus
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginTop: "180px",
                  }}
                >
                  <div
                    className="newsDot"
                    style={{
                      height: "15px",
                      width: "15px",
                      borderRadius: "15px",
                      marginTop: "65px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  ></div>
                  <div
                    style={{
                      height: "25px",
                      width: "25px",
                      marginTop: "-20px",
                      borderRadius: "15px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  ></div>
                  <div
                    style={{
                      textAlign :"justify",
                      fontSize: state.auth.isMobile ? "20px" : "30px",
                      fontWeight: "bold",
                      fontFamily: "Montserrat",
                    }}
                  >
                    1997
                  </div>
                  <div
                    style={{
                      textAlign :"justify",
                      width: "155px",
                      marginTop: "15px",
                      fontSize: "20px",
                      fontFamily: "Montserrat",
                    }}
                  >
                    SSLC Building was established at Our first building campus
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginTop: "180px",
                  }}
                >
                  <div
                    className="newsDot"
                    style={{
                      height: "15px",
                      width: "15px",
                      borderRadius: "15px",
                      marginTop: "65px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  ></div>
                  <div
                    style={{
                      height: "25px",
                      width: "25px",
                      marginTop: "-20px",
                      borderRadius: "15px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  ></div>
                  <div
                    style={{
                      textAlign :"justify",
                      fontSize: state.auth.isMobile ? "20px" : "30px",
                      fontWeight: "bold",
                      fontFamily: "Montserrat",
                    }}
                  >
                    1998
                  </div>
                  <div
                    style={{
                      textAlign :"justify",
                      width: "155px",
                      marginTop: "15px",
                      fontSize: "20px",
                      fontFamily: "Montserrat",
                    }}
                  >
                    SSLC Building was established at Our first building campus
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginTop: "180px",
                  }}
                >
                  <div
                    className="newsDot"
                    style={{
                      height: "15px",
                      width: "15px",
                      borderRadius: "15px",
                      marginTop: "65px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  ></div>
                  <div
                    style={{
                      height: "25px",
                      width: "25px",
                      marginTop: "-20px",
                      borderRadius: "15px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  ></div>
                  <div
                    style={{
                      textAlign :"justify",
                      fontSize: state.auth.isMobile ? "20px" : "30px",
                      fontWeight: "bold",
                      fontFamily: "Montserrat",
                    }}
                  >
                    1999
                  </div>
                  <div
                    style={{
                      textAlign :"justify",
                      width: "155px",
                      marginTop: "15px",
                      fontSize: "20px",
                      fontFamily: "Montserrat",
                    }}
                  >
                    SSLC Building was established at Our first building campus
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginTop: "180px",
                  }}
                >
                  <div
                    className="newsDot"
                    style={{
                      height: "15px",
                      width: "15px",
                      borderRadius: "15px",
                      marginTop: "65px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  ></div>
                  <div
                    style={{
                      height: "25px",
                      width: "25px",
                      marginTop: "-20px",
                      borderRadius: "15px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  ></div>
                  <div
                    style={{
                      textAlign :"justify",
                      fontSize: state.auth.isMobile ? "20px" : "30px",
                      fontWeight: "bold",
                      fontFamily: "Montserrat",
                    }}
                  >
                    2000
                  </div>
                  <div
                    style={{
                      textAlign :"justify",
                      width: "155px",
                      marginTop: "15px",
                      fontSize: "20px",
                      fontFamily: "Montserrat",
                    }}
                  >
                    SSLC Building was established at Our first building campus
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          <div className="aboutabout2" style={{ marginTop: "-300px" }}>
            <Grid container spacing={5}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div
                  style={{
                    fontSize: state.auth.isMobile ? "30px" : "50px",
                    fontFamily: "Montserrat",
                    textAlign: "left",
                    color:
                      state.auth.theme == "dark"
                        ? themeStyleDark.primaryColor
                        : themeStyle.prtmaryColor,
                    fontWeight: "bold",
                  }}
                >
                  Our Curriculum
                </div>
                <br />
                <div
                  style={{
                    fontSize: state.auth.isMobile ? "18px" : "25px",
                    fontFamily: "Montserrat",
                    textAlign: "justify",
                  }}
                >
                  Aspire Grove International ensures that your child gains the
                  best learning experiences through observations and specific
                  age-appropriate planning. Our Medium of instruction is English
                  with emphasis given to learn Kannada and Hindi language also.
                  We strive to create the best learning environment for your
                  children to play, discover and achieve. <br /> <br /> Our
                  curriculum is theme-based and is enhanced with special
                  learning opportunities at each level. All classrooms and
                  teachers collaborate to create an authentic and meaningful
                  learning experience that reach across the curriculum and
                  engage the whole child. <br /> <br /> We take registrations
                  for children from 1.5 Years to 5 years of age and offer a
                  variety of timings to suit our busy parents. Our opening hours
                  are 8 am – 5.30 pm with a choice 5- or 6-day options. We offer
                  morning and afternoon study classes enhanced with different
                  extra-curricular activities.
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    margin: "30px 0px 10px 0px",
                  }}
                >
                  <Link
                    style={{
                      textDecoration: "none",
                      color:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryButtonTextColor
                          : themeStyle.primaryButtonTextColor,
                    }}
                    to={"/about"}
                  >
                    <Button
                      style={{
                        padding: "30px",
                        border:
                          "2px " + state.auth.theme == "dark"
                            ? themeStyleDark.primaryColor
                            : themeStyle.primaryColor + " solid",
                        borderRadius: "45px",
                        height: "30px",
                        fontSize: "20px",
                        fontWeight: "bold",
                        color:
                          state.auth.theme == "dark"
                            ? themeStyleDark.primaryColor
                            : themeStyle.primaryColor,
                      }}
                    >
                      Read More
                    </Button>
                  </Link>
                </div>
              </Grid>

              {/* <Grid item xs={12} md={5}>
                <div className="slider">
                  <div className="slides-container">
                    <div className="slides-inner">
                      <div className="slide">
                        <img
                          style={{
                            width: "100%",
                            objectFit: "cover",
                            margin: "10px",
                            height: "100%",
                          }}
                          src={require("../img/vday.jpeg")}
                        />
                      </div>
                      <div className="slide">
                        <img
                          style={{
                            width: "100%",
                            objectFit: "cover",
                            margin: "10px",
                            height: "100%",
                          }}
                          src={require("../img/krshna.jpeg")}
                        />
                      </div>
                      <div className="slide">
                        <img
                          style={{
                            width: "100%",
                            objectFit: "cover",
                            margin: "10px",
                            height: "100%",
                          }}
                          src={require("../img/pg2.jpg")}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="controls">
                    <Button
                      className="button-carousel"
                      id="prevButton"
                      style={{
                        border: "2px solid " + themeStyle.primaryColor,
                        borderRadius: "25px",
                        height: "30px",
                        fontSize: "15px",
                        color: themeStyle.primaryColor,
                        fontWeight: "bold",
                        padding: "2px 10px 0px 10px",
                      }}
                    >
                      Prev
                    </Button>

                    <Button
                      className="button-carousel"
                      id="nextButton"
                      style={{
                        marginLeft: "15px",
                        border: "2px solid " + themeStyle.primaryColor,
                        borderRadius: "25px",
                        height: "30px",
                        fontSize: "15px",
                        color: themeStyle.primaryColor,
                        fontWeight: "bold",
                        padding: "2px 10px 0px 10px",
                      }}
                    >
                      Next
                    </Button>
                  </div>
                </div>
              </Grid> */}
            </Grid>
          </div>
          <div className="aboutabout2" style={{ marginTop: "-150px" }}>
            <Grid container spacing={5}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div
                  style={{
                    fontSize: "32px",
                    fontFamily: "Montserrat",
                    textAlign: "left",
                    color:
                      state.auth.theme == "dark"
                        ? themeStyleDark.primaryColor
                        : themeStyle.primaryColor,
                    fontWeight: "bold",
                  }}
                >
                  YOUNG Toddlers
                </div>
                <br />
                <div
                  style={{
                    fontSize: state.auth.isMobile ? "18px" : "22px",
                    fontFamily: "Montserrat",
                    textAlign: "justify",
                  }}
                >
                  Our AGIS is child orientated and provides a stimulating,
                  colourful, safe and clean learning environment. We have a
                  sleeping area and a play area which is equipped with age and
                  stage appropriate toys and equipment.
                  <br />
                  <br />
                  Our teachers work in partnership with parents in developing
                  this environment and ensuring that there is lots of cuddling,
                  soothing, talking and singing which allows babies to feel safe
                  and secure in their surroundings.
                  <br />
                  <br />
                  We plan a range of stimulating activities daily and are
                  designed to meet each child’s individual needs. We achieve
                  this by a lot of one-to-one attention, and activities which
                  encourage curiosity and learning.
                  <br />
                  <br />
                </div>
              </Grid>
            </Grid>
            <div
              style={{
                textAlign: "justify",
                marginTop: "50px",
                fontSize: state.auth.isMobile ? "18px" : "22px",
              }}
            >
              <div
                style={{
                  fontSize: "32px",
                  fontFamily: "Montserrat",
                  textAlign: "left",
                  color:
                    state.auth.theme == "dark"
                      ? themeStyleDark.primaryColor
                      : themeStyle.primaryColor,
                  fontWeight: "bold",
                }}
              >
                Toddlers
              </div>
              <br />
              For Toddlers we gently introduce them to a classroom setting by
              incorporating play, engaging stories, music, movement, and fun
              activities. They begin to participate in short lessons, which may
              include themes, stories, comprehension exercises, or focusing on
              numbers and letters.
              <br />
              <br />
              We also introduce them to basic concepts while helping them adapt
              to classroom behaviour, like sitting, listening, and responding
              appropriately. Our teachers create a well-balanced daily schedule,
              allowing children to engage in various educational activities such
              as puzzles and floor-play to enhance their motor skills.
              <br />
              <br />
              With a stress-free and less intense approach, children grow more
              confident, fostering a positive learning environment that
              encourages their development.
            </div>
          </div>
          <div className="aboutabout2" style={{ marginTop: "-150px" }}>
            <Grid container spacing={5}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div
                  style={{
                    fontSize: "32px",
                    fontFamily: "Montserrat",
                    textAlign: "left",
                    color:
                      state.auth.theme == "dark"
                        ? themeStyleDark.primaryColor
                        : themeStyle.primaryColor,
                    fontWeight: "bold",
                  }}
                >
                  FES-1
                </div>
                <br />
                <div
                  style={{
                    fontSize: state.auth.isMobile ? "18px" : "22px",
                    fontFamily: "Montserrat",
                    textAlign: "justify",
                  }}
                >
                  This stage of learning is dedicated to equipping children with
                  the essential skills they’ll need as they transition to
                  mainstream schools.
                  <br />
                  <br />
                  We offer a diverse range of activities, including arts and
                  crafts using materials like paint, clay, playdough, and
                  collages, as well as engaging Storytime sessions featuring a
                  variety of reading materials, from poems to fiction and
                  non-fiction. Children participate in circle time, messy play,
                  outdoor and soft play, role-playing, jigsaw puzzles, water and
                  sand play, and mathematical games that focus on patterns and
                  counting.
                  <br />
                  <br />
                  Moreover, they delve into phonics and letter awareness, which
                  helps them recognize the sounds associated with different
                  letters of the alphabet. Letter formation and recognition are
                  also emphasized, laying a strong foundation for future
                  challenges like reading and writing, ultimately preparing them
                  for the next phase of their educational journey.
                  <br />
                  <br />
                  <br />
                </div>
              </Grid>
            </Grid>
            <div
              style={{
                textAlign: "justify",
                marginTop: "50px",
                fontSize: state.auth.isMobile ? "18px" : "22px",
              }}
            >
              <div
                style={{
                  fontSize: "32px",
                  fontFamily: "Montserrat",
                  textAlign: "left",
                  color:
                    state.auth.theme == "dark"
                      ? themeStyleDark.primaryColor
                      : themeStyle.primaryColor,
                  fontWeight: "bold",
                }}
              >
                FES-2
              </div>
              <br />
              This is a very exciting time and phase of our AGIS. The activities
              are specially designed to ensure a smooth transition and we look
              forward to supporting them.
              <br />
              <br /> We believe that learning takes place in many ways both
              inside and outside the classroom, therefore we ensure that the
              children are subject to rich experiences. We follow the Letters
              and Sounds program for Phonics, which helps the children to become
              confident speakers and readers.
              <br />
              <br />
              Children are encouraged, not only to work on the knowledge of the
              world around them, but to also work on their personal and social
              development, allowing them to become well-rounded, polite and
              happy children, who are able to cope with impending school life
              and education.
              <br />
              <br />
            </div>
            <div
              style={{
                textAlign: "justify",
                marginTop: "50px",
                fontSize: state.auth.isMobile ? "18px" : "22px",
              }}
            >
              <div
                style={{
                  fontSize: "32px",
                  fontFamily: "Montserrat",
                  textAlign: "left",
                  color:
                    state.auth.theme == "dark"
                      ? themeStyleDark.primaryColor
                      : themeStyle.primaryColor,
                  fontWeight: "bold",
                }}
              >
                Camps
              </div>
              <br />
              The setting is buzzing with joyful activities throughout the year
              We offer summer, winter and spring camps in the nursery.
              <br />
              <br />
              The camps promise to be a magical and enriching experience
              designed exclusively for young children. They are carefully
              crafted to provide a safe, fun, and educational environment where
              young minds can thrive, build friendships and create lasting
              memories. <br />
              <br />
              (Public Speaking, Storytelling, Puppet Play, Performing Arts and
              Music)
              <br />
              <br />
              Let’s give our children’s imagination wings, with which they can
              explore and fly high.
              <br />
              <br />
              Contact us for a time filled with laughter and learning.
            </div>
            <div
              style={{
                textAlign: "justify",
                marginTop: "50px",
                fontSize: state.auth.isMobile ? "18px" : "22px",
              }}
            >
              <div
                style={{
                  fontSize: "32px",
                  fontFamily: "Montserrat",
                  textAlign: "left",
                  color:
                    state.auth.theme == "dark"
                      ? themeStyleDark.primaryColor
                      : themeStyle.primaryColor,
                  fontWeight: "bold",
                }}
              >
                Afternoon Care
              </div>
              <br />
              We offer an affordable afternoon programme in the nursery. <br />
              <br />
              This programme goes beyond traditional learning, focusing on
              creative and personality development. <br />
              <br />
              Our teachers have carefully designed an afternoon program that
              contributes significantly to the comprehensive development of
              children by offering extended learning opportunities, promoting
              socialization, incorporating enrichment activities, and preparing
              them for future educational experiences. <br />
              <br />
              Activities include a balance of artistic expression, physical
              activity, social interaction, and emotional awareness. The
              structured yet flexible schedule aims to cater to the unique needs
              and interests of each child while promoting a positive and
              nurturing environment.
            </div>
          </div>
          <br />
          <br />
          {/* <Benchmark /> */}
          <div className="news">
            <div
              style={{
                textAlign: "left",
                marginBottom: "50px",
                marginTop: "50px",
                fontSize: state.auth.isMobile ? "30px" : "30px",
                fontWeight: "bold",
                fontFamily: "Montserrat",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
              }}
            >
              A Glimpse of the Campus
            </div>
            <Grid container spacing={2.5}>
              <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                <div className="icard">
                  <img
                    src={require("../img/AGIS (1).jpeg")}
                    alt="Norway"
                    style={{
                      width: "300px",
                      height: "250px",
                      borderRadius: "10px",
                      objectFit: "contain",
                    }}
                  />
                  <div
                    style={{
                      padding: "0px 10px 0px 10px",
                      fontSize: "20px",
                      color:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                      fontFamily: "Montserrat",
                      textAlign: "justify",
                      fontWeight: 600,
                    }}
                  ></div>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                <div className="icard">
                  <img
                    src={require("../img/AGIS (7).jpeg")}
                    alt="Norway"
                    style={{
                      width: "300px",
                      height: "250px",
                      borderRadius: "10px",
                      objectFit: "contain",
                    }}
                  />
                  <div
                    style={{
                      padding: "0px 10px 0px 10px",
                      fontSize: "20px",
                      color:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                      fontFamily: "Montserrat",
                      textAlign: "justify",
                      fontWeight: 600,
                    }}
                  ></div>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                <div className="icard">
                  <img
                    src={require("../img/AGIS (4).jpeg")}
                    alt="Norway"
                    style={{
                      width: "300px",
                      height: "250px",
                      borderRadius: "10px",
                      objectFit: "contain",
                    }}
                  />
                  <div
                    style={{
                      padding: "0px 10px 0px 10px",
                      fontSize: "20px",
                      color:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                      fontFamily: "Montserrat",
                      textAlign: "justify",
                      fontWeight: 600,
                    }}
                  ></div>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                <div className="icard">
                  <img
                    src={require("../img/AGIS (7).jpeg")}
                    alt="Norway"
                    style={{
                      width: "300px",
                      height: "250px",
                      borderRadius: "10px",
                      objectFit: "contain",
                    }}
                  />
                  <div
                    style={{
                      padding: "0px 10px 0px 10px",
                      fontSize: "20px",
                      color:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                      fontFamily: "Montserrat",
                      textAlign: "justify",
                      fontWeight: 600,
                    }}
                  ></div>
                </div>
              </Grid>
            </Grid>
            <br />
            <br />
            <h1 style={{ textAlign: "center" }}>
              “Enter the magical world of Aspire Grove International Preschool,
              where learning dances with laughter and every child’s journey is
              celebrated”
            </h1>
            {/* <Grid
              container
              spacing={2.5}
              style={{ justifyContent: "center", paddingBottom: "100px" }}
            >
              <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                <div className="icard">
                  <img
                    src={require("../img/entrance.jpg")}
                    alt="Norway"
                    style={{
                      width: "300px",
                      height: "250px",
                      borderRadius: "10px",
                      objectFit: "contain",
                    }}
                  />
                  <div
                    style={{
                      padding: "0px 10px 0px 10px",
                      fontSize: "20px",
                      color:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                      fontFamily: "Montserrat",
                      textAlign: "justify",
                      fontWeight: 600,
                    }}
                  >
                    School Entrance
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                <div className="icard">
                  <img
                    src={require("../img/redday.jpeg")}
                    alt="Norway"
                    style={{
                      width: "300px",
                      height: "250px",
                      borderRadius: "10px",
                      objectFit: "contain",
                    }}
                  />
                  <div
                    style={{
                      padding: "0px 10px 0px 10px",
                      fontSize: "20px",
                      color:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                      fontFamily: "Montserrat",
                      textAlign: "justify",
                      fontWeight: 600,
                    }}
                  >
                    Red day
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                <div className="icard">
                  <img
                    src={require("../img/krshna.jpeg")}
                    alt="Norway"
                    style={{
                      width: "300px",
                      height: "250px",
                      borderRadius: "10px",
                      objectFit: "contain",
                    }}
                  />
                  <div
                    style={{
                      padding: "0px 10px 0px 10px",
                      fontSize: "20px",
                      color:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                      fontFamily: "Montserrat",
                      textAlign: "justify",
                      fontWeight: 600,
                    }}
                  >
                    Gokulashtami
                  </div>
                </div>
              </Grid>
            </Grid> */}
          </div>
          <br />
          <br />
          <br />
          <br />
          <Explore />
          <VisitUs />
          <Footer />
        </div>
      );
    }
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        opacity: transition ? 1 : 0,
      }}
    >
      {getContent()}
    </div>
  );
}
